import { createFileRoute } from '@tanstack/react-router'
import { PIIDashboard } from '@/features/pii/pii-dashboard'

export const Route = createFileRoute('/_authenticated/command-center/pii')({
  component: PIIDashboard,
})
